import CheckoutOverlay from '../../CheckoutOverlay';
import AfterPayClearPayOverlayLazyLoader from './AfterPayClearPayOverlayLazyLoader';

function AfterPayClearPayOverlay() {
  return (
    <CheckoutOverlay
      popup
      nopadding
      fullscreenMobile
    >
      <AfterPayClearPayOverlayLazyLoader />
    </CheckoutOverlay>
  );
}

AfterPayClearPayOverlay.propTypes = {};

export default AfterPayClearPayOverlay;
